import { call, put, select, take } from "redux-saga/effects";

import { getIsSourcedFromDesignTool } from "../../lib/selectors";
import { fetchDesignToolMetadata } from "./design-tool.actions";

export function* designToolSaga() {
  yield take("proposal/fetch/fulfilled");
  const isDesignToolDesign = yield select(getIsSourcedFromDesignTool);
  if (isDesignToolDesign) {
    const data = yield call(fetchDesignToolMetadata);
    yield put(data);
  }
}
